<template>
<div class="chapter">
<div class="inner_page">
<p class="right1"><span class="textStyle3">SURFEIT<br/>
  OF LAMPREYS</span></p>
<p class="right1"><span class="textStyle4">Ngaio Marsh</span></p>
<p class="right1"><span class="textStyle0">F</span><span class="textStyle1">ELONY</span> <span class="textStyle0">&amp; M</span><span class="textStyle1">AYHEM</span> <span class="textStyle0">P</span><span class="textStyle1">RESS</span> <span class="textStyle2">•</span> <span class="textStyle0">N</span><span class="textStyle1">EW</span> <span class="textStyle0">Y</span><span class="textStyle1">ORK</span></p>
<div class="right2"><img alt="" src="Images/frn_fig_002.png" width="50%"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?100894d4